import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useSearchParams } from "react-router-dom";
import DealsEditor from "../deals-editor";

const CreateDeal = () => {
  const [searchParams] = useSearchParams();
  const pipelineId = searchParams.get("pipelineId");

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neuen Deal erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <DealsEditor pipelineId={pipelineId || undefined} />
      </div>
    </div>
  );
};

export default CreateDeal;
